import { useQuery } from '@tanstack/react-query';
import { useInstitutionStore } from '@/modules/auth/presentation/store/institution.store';
import { authContainer } from '@/modules/auth/di/container';
import { triContainer } from '../../di/container';

export function useClassTriConfidence(editionId: string) {
  const { institutionName } = useInstitutionStore();

  const isAuthenticated = institutionName
    ? authContainer.repository.isAuthenticated(institutionName)
    : false;

  return useQuery({
    queryKey: ['tri', 'class-tri-confidence', institutionName, editionId],
    queryFn: () => triContainer.repository.getClassTriConfidence(editionId),
    enabled: isAuthenticated && !!editionId,
    retry: false,
  });
}
